module.exports = __webpack_public_path__ + "img/lb.742af69c.png";